
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCoJzA3ROgXVQlx73h7oXkZaUFwFCWBRRk",
  authDomain: "art-vault-s26pj.firebaseapp.com",
  projectId: "art-vault-s26pj",
  storageBucket: "art-vault-s26pj.appspot.com",
  messagingSenderId: "842745424135",
  appId: "1:842745424135:web:dc1e3e379e76b4d28abda2"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app);
const storage = getStorage(app, "gs://art-vault-s26pj.firebasestorage.app");


export { app, auth, googleProvider, db, storage };
